<template>
    <div v-if="currentStep >= 1">
        
        
        <!--Schritte Mobile-->
    <div class="row g-3 w-100 d-md-none">
        <div :class="['col', 'mx-1', getStepClass(1)]">
            <div :class="[`${classPrefix}schritt-kreis`, 'm-1']">
                <span :class="`${classPrefix}schritt-nummer`">1</span>
                <span :class="`${classPrefix}schritt-haken`">
                    <SchritthakenMobileIcon :backgroundColor="backgroundColor" :checkColor="checkColor" />
                </span>
            </div>
        </div>

        <div :class="['col', 'mx-1', getStepClass(2)]">
            <div :class="[`${classPrefix}schritt-kreis`, 'm-1']">
                <span :class="`${classPrefix}schritt-nummer`">2</span>
                <span :class="`${classPrefix}schritt-haken`">
                    <SchritthakenMobileIcon :backgroundColor="backgroundColor" :checkColor="checkColor" />
                </span>
            </div>
        </div>

        <div :class="['col', 'mx-1', getStepClass(3)]">
            <div :class="[`${classPrefix}schritt-kreis`, 'm-1']">
                <span :class="`${classPrefix}schritt-nummer`">3</span>
                <span :class="`${classPrefix}schritt-haken`">
                    <SchritthakenMobileIcon :backgroundColor="backgroundColor" :checkColor="checkColor" />
                </span>
            </div>
        </div>

        <div :class="['col', 'mx-1', getStepClass(4)]">
            <div :class="[`${classPrefix}schritt-kreis`, 'm-1']">
                <span :class="`${classPrefix}schritt-nummer`">4</span>
                <span :class="`${classPrefix}schritt-haken`">
                    <SchritthakenMobileIcon :backgroundColor="backgroundColor" :checkColor="checkColor" />
                </span>
            </div>
        </div>
    </div>

    <!-- Schritte Desktop -->
    <div class="row g-3 w-100 d-none d-md-flex">
        <div :class="['col', 'mx-1', getStepClass(1, true)]">
            <div class="d-flex justify-content-center align-items-center my-2">
                <span :class="`${classPrefix}schritt-nummer-desktop`">Schritt 1</span>
                <span :class="[`${classPrefix}schritt-bearbeiten-desktop`, 'ms-2', 'ms-md-3']">
                    <SchrittstiftIcon />
                </span>
                <span :class="[`${classPrefix}schritt-haken-desktop`, 'ms-2', 'ms-md-3']">
                    <SchritthakenIcon backgroundColor="#fff" :checkColor="checkColor" />
                </span>
            </div>
        </div>

        <div :class="['col', 'mx-1', getStepClass(2, true)]">
            <div class="d-flex justify-content-center align-items-center my-2">
                <span :class="`${classPrefix}schritt-nummer-desktop`">Schritt 2</span>
                <span :class="[`${classPrefix}schritt-bearbeiten-desktop`, 'ms-2', 'ms-md-3']">
                    <SchrittstiftIcon />
                </span>
                <span :class="[`${classPrefix}schritt-haken-desktop`, 'ms-2', 'ms-md-3']">
                    <SchritthakenIcon backgroundColor="#fff" :checkColor="checkColor" />
                </span>
            </div>
        </div>

        <div :class="['col', 'mx-1', getStepClass(3, true)]">
            <div class="d-flex justify-content-center align-items-center my-2">
                <span :class="`${classPrefix}schritt-nummer-desktop`">Schritt 3</span>
                <span :class="[`${classPrefix}schritt-bearbeiten-desktop`, 'ms-2', 'ms-md-3']">
                    <SchrittstiftIcon />
                </span>
                <span :class="[`${classPrefix}schritt-haken-desktop`, 'ms-2', 'ms-md-3']">
                    <SchritthakenIcon backgroundColor="#fff" :checkColor="checkColor" />
                </span>
            </div>
        </div>

        <div :class="['col', 'mx-1', getStepClass(4, true)]">
            <div class="d-flex justify-content-center align-items-center my-2">
                <span :class="`${classPrefix}schritt-nummer-desktop`">Schritt 4</span>
                <span :class="[`${classPrefix}schritt-bearbeiten-desktop`, 'ms-2', 'ms-md-3']">
                    <SchrittstiftIcon />
                </span>
                <span :class="[`${classPrefix}schritt-haken-desktop`, 'ms-2', 'ms-md-3']">
                    <SchritthakenIcon backgroundColor="#fff" :checkColor="checkColor" />
                </span>
            </div>
        </div>
    </div>

    </div> <!-- wrapper um alles-->
</template>

<script setup>
    import { computed } from 'vue'
    import { storeToRefs } from 'pinia'
    import { useRechnerStore } from '../../stores/rechner.js'
    import { useMainStore } from '../../stores/useMainStore.js'
    import SchritthakenIcon from '../icons/schritthaken_icon.vue'
    import SchrittstiftIcon from '../icons/schrittstift_icon.vue'
    import SchritthakenMobileIcon from '../icons/schritthaken_mobile_icon.vue'
 

    const mainStore = useMainStore()
    const rechnerStore = useRechnerStore()
    const { stepStatus: currentStep } = storeToRefs(rechnerStore)

    // Theme-Werte aus dem zentralen MainStore
    const classPrefix = computed(() => mainStore.classPrefix)
    const checkColor = computed(() => mainStore.themeCheckColor)
    const backgroundColor = '#fff'

    

    // Ermittelt die Klasse für einen Schritt basierend auf currentStep
    const getStepClass = (stepNumber, isDesktop = false) => {
        const suffix = isDesktop ? '-desktop' : ''
        
        if (stepNumber === currentStep.value) {
            return `${classPrefix.value}schritt-aktiv${suffix}`
        } else if (stepNumber < currentStep.value) {
            return `${classPrefix.value}schritt-vollendet${suffix}`
        } else {
            return `${classPrefix.value}schritt${suffix}`
        }
    }
</script>
